import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IUser } from "@defs/user";

interface AuthState {
  loading: boolean;
  currentUser: IUser | null;
}

const initialState: AuthState = {
  loading: true,
  currentUser: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    start(state) {
      state.loading = true;
    },

    setCurrentUser(state, action: PayloadAction<IUser>) {
      state.loading = false;
      state.currentUser = action.payload;
    },

    resetCurrentUser(state) {
      state.loading = initialState.loading;
      state.currentUser = initialState.currentUser;
    },
  },
});

export const { start, setCurrentUser, resetCurrentUser } = authSlice.actions;

export default authSlice.reducer;
